<template>
  <main-content with_go_back_bar>
    <kt-panel class="p-3">
      <div
        class="container p-3 pt-5 my-4 border in-border-header"
        style="padding-top: 1.5rem !important"
      >
        <kt-form-section is-first>
          <div class="section-header">{{ $t("aside.change_agent") }}</div>
          <kt-row class="p-2">
            <kt-col lg="6" md="6" xs="12">
              <kt-form-label for="wage my-2"> {{ $t("aside.marketing_search_agent") }} </kt-form-label>
              <v-select
                v-model="searchAgent"
                @input="setSelectedForAgent"
                class="vSelect form-control"
                :options="optionsAgent"
                :filterable="false"
                @search="onSearchAgent"
                :getOptionLabel="(user) => user.id"
              >
                <template slot="no-options"> {{ $t('namad.not_found') }} </template>
                <template slot="option" slot-scope="options">
                  <div class="d-flex align-items-center">
                    {{ options.first_name + " " + options.last_name }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="options">
                  <div class="selected d-flex align-items-center">
                    {{ options.first_name + " " + options.last_name }}
                  </div>
                </template>
              </v-select>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" class="sm-mt">
              <kt-form-group>
                <kt-form-label for="terminal_number">
                  {{ $t("label.terminal_number") }}
                  <span class="pb-3">( {{ $t('pardakht_shakhsi.form.span.optional') }} )</span>
                </kt-form-label>
                <kt-form-control type="text" id="terminal_number" name="terminal_number" v-model="terminal_number">
                </kt-form-control>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-button
                @click="changeAgent()"
                id="form-btn"
                class="btn btn-success btn-wide text-center py-2"
                variant="success"
              >
                {{ $t("money_request.submit") }}
              </kt-button>
            </kt-col>
            <kt-col lg="12" md="12" xs="12"> </kt-col>
          </kt-row>
        </kt-form-section>
      </div>
    </kt-panel>
  </main-content>
</template>

<script>
import mainContent from "@/components/main-content";
import { ApiService } from "@/common/api.service";
import toastr from "toastr";
import { KTApp } from "@/plugins/core/app";
import $ from "jquery";
export default {
  name: "posAgentSetting",
  components: {
    "main-content": mainContent,
  },
  data() {
    return {
      searchAgent: "",
      optionsAgent: [],
      new_agent_id: "",
      terminal_number: ""
    };
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };

      return toastr;
    },
  },
  methods: {
    onSearchAgent(search, loading) {
      this.searchForAcceptor(loading, search, this);
    },
    searchForAcceptor: _.debounce((loading, search, vm) => {
      ApiService.query(`user/search?q=${search}`)
        .then((res) => {
          vm.optionsAgent = res.data;
          loading(false);
        })
        .catch((error) => {
          return error
        });
    }, 600),
    setSelectedForAgent(value) {
      this.new_agent_id = value.id
    },
    changeAgent(){
      let form_btn = $('#form-btn')
      KTApp.progress(form_btn)
      this.$store.dispatch('marketing/changeAgent',{
        visitor_id: this.$route.params.visitor_id,
        agent_id: this.new_agent_id,
        terminal_number: this.terminal_number
      }).then(response => {
        this.toastr.success(response.data.message)
        this.$router.push('/marketing/pos-acceptors#pos-acceptors')
      }).catch(({response}) => {
        KTApp.unprogress(form_btn)
        this.toastr.error(response.data.message)
        for (let err in response.data.data) {
            this.toastr.error(response.data.data[err][0]);
        }
      }).finally(() => {
        KTApp.unprogress(form_btn)
      })
    }
  },
  mounted(){
    this.onSearchAgent(this.$route.params.agent_id, false)
  }
};
</script>

<style scoped>
.vSelect {
  --vs-actions-padding: 0;
  --vs-border-color: #fff;
}

@media screen and (max-width:768px) {
  .sm-mt{margin: 1.5rem 0 0 0;}
}
</style>
